import { ElasticFilterType } from '../../../osd/filters/filter-interfaces';
import IsOneOfFilterParser from '../../../osd/filters/parsers/is-one-of-filter-parser';
import { ElasticsearchFieldModel } from '../../../elasticsearch/elasticsearch-field';
import { ElasticsearchFilterModel, ElasticsearchFilterOperator, } from '../../../elasticsearch/elasticsearch-filter';
import { BaseAlertFilterParser } from './base';
/**
 * Elastic to ElasticsearchFilterModel 'IS ONE OF' filter parser
 */
export class AlertFilterIsOneOfFilterParser extends BaseAlertFilterParser {
    constructor() {
        super(new IsOneOfFilterParser());
    }
    getFilter(elasticFilter, negate) {
        const metadata = this.getMetadata(elasticFilter, negate);
        if (!metadata)
            return null;
        const filter = new ElasticsearchFilterModel();
        filter.type = ElasticsearchFilterOperator.IsOneOf;
        filter.value = metadata.params;
        filter.negate = metadata.negate;
        filter.field = new ElasticsearchFieldModel();
        filter.field.name = metadata.key ?? '';
        return filter;
    }
    getElasticFilter(filter) {
        if (filter.type !== ElasticsearchFilterOperator.IsOneOf || !filter.field)
            return null;
        return {
            [this.baseFilterParser.elasticKey]: {
                minimum_should_match: 1,
                should: filter.value.map(value => ({
                    [ElasticFilterType.MatchPhrase]: { [filter.field.name]: value },
                })),
            },
        };
    }
}
//# sourceMappingURL=is-one-of.js.map